import { render } from "./BaseTextarea.vue?vue&type=template&id=085f376d&scoped=true"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"

import "./BaseTextarea.vue?vue&type=style&index=0&id=085f376d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085f376d"]])

export default __exports__